import { useSetRecoilState } from "recoil";
import { exWxContentsState } from "../../../store/ExWxContentsState";
import WxContentsDispatcher from "./WxContentsDispatcher";

const ExWxContentsDispatcher = (props) => {
  const setValue = useSetRecoilState(exWxContentsState(props.contentsID));

  props.contents.setExDispatcher((value) => {
    setValue(value);
  });

  return <WxContentsDispatcher {...props}/>
};

export default ExWxContentsDispatcher;
